module.exports = __webpack_public_path__ + "static/media/detailedExchangeWhite.ba1b87cd.svg";